import { Lead } from "../types";
import { LeadHeader } from "./LeadHeader";
import { LeadContactInfo } from "./LeadContactInfo";
import { LeadActions } from "./LeadActions";

interface LeadContentProps {
  lead: Lead;
  onEdit: (e: React.MouseEvent) => void;
  onDelete: () => void;
  onConvert: (e: React.MouseEvent) => void;
}

export const LeadContent = ({
  lead,
  onEdit,
  onDelete,
  onConvert,
}: LeadContentProps) => {
  return (
    <div className="space-y-4">
      <LeadHeader
        firstName={lead.first_name}
        lastName={lead.last_name}
        leadSource={lead.lead_source}
        onEdit={onEdit}
        onDelete={onDelete}
      />
      
      <div className="text-sm text-gray-600 font-medium">
        {lead.insurance_type}
      </div>
      
      <LeadContactInfo 
        email={lead.email}
        phone={lead.phone}
        quotedAmount={lead.quoted_amount}
      />

      <LeadActions
        pipelineStage={lead.pipeline_stage}
        onConvert={onConvert}
      />
    </div>
  );
};